import PropTypes from 'prop-types';
import React from 'react';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { TitleSummary } from '../../style';

export const MultipleListComponent = ({ field, onEdit }) => {
  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>
          {field.label}
          {onEdit != null ? <ButtonEditSummaryItem onClick={onEdit} /> : null}
        </TitleSummary>

        {field.value?.map((item, index) => (
          <p key={index}>{item.join(' > ')}</p>
        ))}
      </React.Fragment>
    </>
  );
};

MultipleListComponent.propTypes = {
  field: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};
